import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { mergeMap, map, catchError } from 'rxjs/operators';

import { RewardService } from '../../pages/rewards/reward.service';
import { NotificationService } from '../../shared/services/notification.service';
import * as rewardActions from '../actions/rewards.actions';
import { Reward } from '../../pages/rewards/reward';
import { PremiitError } from '../../utils/premiit-error';
import { of } from 'rxjs';

@Injectable()
export class RewardEffects {
  constructor(private actions$: Actions, private rewardService: RewardService, private notify: NotificationService,
    private router: Router) {}

  public createRewardEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rewardActions.createRewardAction),
      mergeMap((action) => {
        return this.rewardService.createReward(action.reward)
          .pipe(
            map((createdReward: Reward) => {
              this.notify.success('Recompensa creada con éxito');
              this.router.navigate(['rewards']);
              return rewardActions.createRewardSuccessAction({ reward: createdReward });
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(rewardActions.createRewardError({ error }));
            })
          );
      })
    )
  );

  public findRewardEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rewardActions.getRewardsAction),
      mergeMap((action) => {
        return this.rewardService.getRewards()
          .pipe(
            map((rewards: Reward[]) => {
              return rewardActions.getRewardsSuccessAction({ rewards });
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(rewardActions.getRewardsError({ error }));
            })
          );
      })
    )
  );

  public updateRewardEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rewardActions.updateRewardAction),
      mergeMap((action) => {
        return this.rewardService.updateReward(action.reward)
          .pipe(
            map((updatedReward: Reward) => {
              this.notify.success('Recompensa actualizada con éxito');
              return rewardActions.updateRewardSuccessAction({ reward: updatedReward });
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(rewardActions.updateRewardError({ error }));
            })
          );
      })
    )
  );

  public deleteRewardEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rewardActions.deleteRewardAction),
      mergeMap((action) => {
        return this.rewardService.updateReward(action.reward)
          .pipe(
            map((deletedReward: Reward) => {
              this.notify.success('Recompensa eliminada con éxito');
              return rewardActions.deleteRewardSuccessAction({ reward: deletedReward });
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(rewardActions.deleteRewardErrorAction({ error }));
            })
          );
      })
    )
  );
}
